import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import { ContentLayout, Header, Link } from "@amzn/awsui-components-react";
import React, { useState } from "react";
import QuickSightDashboard from "../dashboard/QuicksightDashboard";
import { useSearchParams } from "react-router-dom";

export const UATLandingPage = () => {
  const [isWizardVisible, setIsWizardVisible] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [shareHandler, setShareHandler] = useState<
    (() => Promise<string>) | null
  >(null);

  return (
    <>
      <SpaceBetween size="xl">
        <ContentLayout
          defaultPadding
          header={
            <SpaceBetween size="m">
              <Header
                variant="h1"
                info={
                  <Link
                    href={
                      "https://w.amazon.com/bin/view/AmazonVideo/TRACK/Systems/Cyberman/CybermanShadowTesting"
                    }
                    variant="info"
                  >
                    Info
                  </Link>
                }
              >
                Raven
              </Header>
            </SpaceBetween>
          }
        >
          <SpaceBetween size={"xl"}>
            <QuickSightDashboard
              stage={"Prod"}
              dashboardType="testing"
              searchParams={searchParams}
              setSearchParams={setSearchParams}
              setShareHandler={setShareHandler}
            />
          </SpaceBetween>
        </ContentLayout>
      </SpaceBetween>
    </>
  );
};
